const enum Cookies {
  PWA_NEXT_ENABLED = 'pwa-next-enabled',
  NESTPICK_UTM = 'nestpick',
  HOME_TO_GO_UTM = 'hometogo',
  USER_IDENTIFIER_COOKIE_NAME = 'ha_anonymous_id',
  FEATURES = 'ha-feature-flags',
}

export default Cookies;
